// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChooseWeek{
    margin-top: 50px;
}
.ChooseWeek button{
    padding: 5px 5px;
}
.ChooseWeek select{
    padding: 1px 1px;
    margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/choose_week/choose_week.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".ChooseWeek{\n    margin-top: 50px;\n}\n.ChooseWeek button{\n    padding: 5px 5px;\n}\n.ChooseWeek select{\n    padding: 1px 1px;\n    margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
